/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import * as React from 'react';
import { BasicChart } from 'src/core/components/BasicChart';
import { getScopedTheme } from 'src/core/themes/luisStylist';
import { ChartDataProps } from 'src/core/types/chart';
import { transformDonutChartData } from 'src/core/utils/chartDataTransforms';

require('./gaugeChartStyles.less');

export type GaugeChartProps = ChartDataProps<string, number> & {
    color?: string[];
};

const theme = getScopedTheme('GaugeChart');
/**
 * The gauge chart component
 *
 * @params props the properties of the donut chart.
 */
export const GaugeChart = (props: GaugeChartProps) => {
    const { color = [theme.color], xData, yData } = props;

    const configs: c3.ChartConfiguration = {
        data: {
            columns: transformDonutChartData(xData, yData),
            type: 'gauge'
        },
        gauge: {
            label: {
                show: false
            },
            min: 0,
            max: 100,
            units: '%',
            width: 25
        },
        color: {
            pattern: color
        },
        size: {
            height: 100,
            width: 202
        }
    };

    return <BasicChart {...configs} className="js-gauge-chart" />;
};
